import { extractAllBlocksFromTpl, blockRegistry } from "@okf/ootils";



export const fixedGetDataConfig = {
    
    findQuery: { "kp_published_status": "published"},

    population: [{path: "meta.kp_contributed_by", model: 'user', select: ['name', 'avatar']}],
    useAggregation: true,
    lookupConfig: [
        {
            $lookup: {
                from: 'users',
                localField: "meta.kp_contributed_by",
                foreignField: '_id',
                as: 'meta.kp_contributed_by',
                pipeline:[
                { $project:{name:1,avatar:1}}	
                ]
              }
        },
        {
            $unwind: {
                path: `$meta.kp_contributed_by`,
                preserveNullAndEmptyArrays: true,
            }
        }
    ]
}

/**
 * more performant.
 * if excludeLexicalFields is true and a tpl is provided, 
 * then we unproject the lexical fields IF a '1' type of projection isnt already used
 */
export const injectFixedGetDataConfig = ({getDataConfig = {}, tpl, excludeLexicalFields = false, isSelfManaged = false}) => {

    let toReturn = {
        ...fixedGetDataConfig,
        ...getDataConfig,
        // Self-managed listings show a per-row annotation count badge.
        // BE translates this declarative flag into an $addFields stage that
        // derives `annotationCount` (distinct annotation count via
        // $setUnion of annoDataIds across all tag fragments) from
        // annotations.tags.tags.data BEFORE the heavy annotations array
        // gets projected out.
        ...(isSelfManaged ? { includeAnnotationCount: true } : {})
    }
    if(!excludeLexicalFields){
        return toReturn;
    }

    //else we wanna skip lexical fields;

    if(!tpl){
        //but we need tpl for that. so if that isnt there
        //just return toReturn;
        return toReturn;
    }

    //now check if there is a '1' type projection already in the getdataconfig;
    //cuz if it is, we cant do anything, we simply return toReturn
    if(toReturn.projection && Object.values(toReturn.projection).every(v => parseInt(v) === 1)){
        return toReturn
    }

    //else lets do it
    const allBlocks = extractAllBlocksFromTpl({tpl});

    // Project out heavy-payload blocks (Lexical etc.) from listing fetches.
    // Membership comes from blockRegistry.excludeFromListingProjection capability,
    // with unregistered fallbacks below.
    const excludedComps = [
        ...blockRegistry.getComps('excludeFromListingProjection'),
        // Unregistered fallbacks — remove as blocks get registered
        // (currently empty since LexicalTextEditor is already registered)
    ];
    const alwaysExcludedFieldsProjection = { annotations: 0 };

    // Short Text fields are Lexical blocks too (props.shortText — the canonical
    // marker, keep in sync with okf-be directImportFieldTypeOptions.js), but
    // they hold small values and MUST stay in listings — otherwise names/
    // labels render blank in the dataset table. Only long-form Lexical blocks
    // are heavy enough to project out. The comp check is belt-and-braces —
    // only the Short Text preset writes this prop today — but an exemption
    // that removes a field from the projection should never fire on a comp we
    // did not mean it for.
    const isShortTextBlock = (bl) =>
        bl.comp === "LexicalTextEditor" && bl.props?.shortText === true;

    const heavyPayloadValuePaths0Projection = allBlocks
        .filter(bl => excludedComps.includes(bl.comp) && !isShortTextBlock(bl))
        .reduce((acc, bl) => ({...acc, [bl.valuePath]: 0}), alwaysExcludedFieldsProjection)


    const finalProjection = {
        ...(toReturn.projection || {}),
        ...heavyPayloadValuePaths0Projection
    }


    return ({
        ...toReturn,
        ...Object.values(finalProjection).length > 0
        ? {projection: finalProjection} : {}
    })

}